import { buildQueryFactory } from "ra-data-graphql-simple/lib/buildQuery";
import buildVariables from "ra-data-graphql-simple/lib/buildVariables";
import appBuildGqlQuery from "./appBuildGqlQuery";
import appResponseParser from "./responseParser";

export const appBuildQuery = introspection =>
  (fetchType, resource, params) =>
    buildQueryFactory(buildVariables, appBuildGqlQuery, appResponseParser)(introspection)(fetchType, resource, params)
;
